import axios from 'axios';
import { getRootDomain } from 'src/constants/app.constant';
import { getCookie } from 'src/utils/common.util';

export const axiosGet = async (url, option) => {
  return axios.get(url, option);
};

const generateAPIService = () => {
  const token = getCookie('token');

  let config = {
    baseURL: getRootDomain(),
  };
  if (token) {
    config = Object.assign(
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      },
      config
    );
  }

  return axios.create(config);
};

export default generateAPIService;
